<script>
import forminput from "../formcomponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import sendinvite from "@/models/sendinvite";

export default {
  mixins: [apibtoast, apigeneric, sendinvite],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
  },
  created() {
    this.FormData = this.sendinviteData;
  },
  methods: {
    Get() {},
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.Post(
          this.$config.API_URL_2 + "mzneposta/sendinvite",
          this.FormData
        ).then((res) => {
          if (res) {
            this.$bvModal.hide("sendinvite");
          }
        });
      }
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="sendinvite"
      size="lg"
      :title="$t('sendinvite.AddEdit.FormTitle')"
      title-class="font-18"
      hide-footer
    >
      <br />
      <Form @submit.prevent="onSubmit">
        <div class="row mt-5">
          <div class="col-md-12">
            <forminput
              :FormDataType="FormDataType.Recievermailadress"
              :Value="FormData.Recievermailadress"
              :v="$v.FormData.Recievermailadress"
              @input="FormData.Recievermailadress = $event"
            />
          </div>
        </div>

        <button class="btn btn-primary" type="submit">
          {{ $t("sendinvite.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
